module.exports = __webpack_public_path__ + "media/images/favicon-ec3dc29f.ico";